import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import topper10 from '../../assets/TopperList10Class.jpeg';
import topper12 from '../../assets/TopperList12.jpeg';
import LineSeperator from '../ui/LineSeperator';
import '../../stylings/Topper.css';

const toppers = [
  {
    id: 1,
    img: topper10,
    class: 'Class X – Board Results 2024',
    desc: 'Our Class X students achieved outstanding results with 98% students scoring above 80%.',
  },
  {
    id: 2,
    img: topper12,
    class: 'Class XII – Board Results 2024',
    desc: 'Class XII students excelled in Science, Commerce & Humanities streams with stellar performances.',
  },
];

const alumni = [
  { name: 'Rahul Sharma', year: 'Batch 2015', achievement: 'IIT Delhi – Computer Science', emoji: '🎓' },
  { name: 'Priya Gupta', year: 'Batch 2017', achievement: 'AIIMS – Medical Professional', emoji: '🏥' },
  { name: 'Amit Kumar', year: 'Batch 2012', achievement: 'IAS Officer – UPSC 2019', emoji: '🏛️' },
  { name: 'Neha Singh', year: 'Batch 2018', achievement: 'National Athlete – Bronze Medalist', emoji: '🏅' },
];

export default function Topper() {
  return (
    <section className="topper-section">
      <div className="container-fluid px-5">
        <LineSeperator title="School Achievements" />
        <div className="row g-5 mt-2">
          {/* Topper Slider */}
          <div className="col-lg-6">
            <h4 className="topper-sub-heading">Board Toppers</h4>
            <Swiper
              modules={[Autoplay, Pagination]}
              autoplay={{ delay: 3500 }}
              pagination={{ clickable: true }}
              loop
              className="topper-swiper"
            >
              {toppers.map((t) => (
                <SwiperSlide key={t.id}>
                  <div className="topper-card">
                    <img src={t.img} alt={t.class} className="topper-img" />
                    <div className="topper-info">
                      <h5>{t.class}</h5>
                      <p>{t.desc}</p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Alumni Cards */}
          <div className="col-lg-6">
            <h4 className="topper-sub-heading">Notable Alumni</h4>
            <div className="row g-3">
              {alumni.map((a, i) => (
                <div key={i} className="col-md-6">
                  <div className="alumni-card">
                    <div className="alumni-emoji">{a.emoji}</div>
                    <div className="alumni-info">
                      <h6 className="alumni-name">{a.name}</h6>
                      <span className="alumni-year">{a.year}</span>
                      <p className="alumni-achievement">{a.achievement}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
